import { forwardRef, type Ref, type SVGProps } from "react";
const IconShieldOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2c.03.018 3.27 2.02 5.5 3 1.459.642 3.719 1.352 5.117 1.77.758.226 1.318.867 1.355 1.658.09 1.908.034 5.787-1.293 10.697l-.171.58c-1.906 5.897-7.785 9.058-9.813 9.994a1.64 1.64 0 0 1-1.392 0c-2.092-.967-8.288-4.304-9.983-10.574-1.327-4.91-1.382-8.789-1.293-10.697.037-.79.598-1.432 1.357-1.658C6.782 6.352 9.04 5.642 10.5 5c2.24-.985 5.5-3 5.5-3m0 2.333c-.27.16-.58.34-.916.533-1.107.634-2.558 1.428-3.78 1.965-1.563.687-3.886 1.417-5.284 1.835-.072 1.8.003 5.393 1.23 9.938.71 2.622 2.38 4.702 4.217 6.28a20.8 20.8 0 0 0 4.532 2.93c.987-.467 2.789-1.429 4.534-2.93 1.836-1.578 3.507-3.659 4.216-6.28 1.228-4.545 1.302-8.138 1.23-9.938-1.399-.419-3.722-1.148-5.285-1.835-1.221-.537-2.671-1.332-3.777-1.965A81 81 0 0 1 16 4.333" />
  </svg>
);
const ForwardRef = forwardRef(IconShieldOutlineSVG);
ForwardRef.displayName = "IconShieldOutline";
export { ForwardRef as IconShieldOutline };
